import { render, staticRenderFns } from "./ProfileOwn.vue?vue&type=template&id=d9d0b89a&scoped=true&"
import script from "./ProfileOwn.vue?vue&type=script&lang=js&"
export * from "./ProfileOwn.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOwn.vue?vue&type=style&index=0&id=d9d0b89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d0b89a",
  null
  
)

export default component.exports